import React from 'react';
import {
  COLOR_BY_WIN_TYPE,
  ROUND_BET_TYPE_VIEW,
  ROUND_WIN_TYPE,
  WIN_TYPE_NAME,
} from '../../../enums/betTypesEnum';

function ResultItemMob({ roundData: { winType, isPairWin } }) {
  return (
    <div className='bottom-left-column-items'>
      <div className={`player-chips small ${COLOR_BY_WIN_TYPE[ROUND_WIN_TYPE[winType]]}`}>
        {typeof winType === 'number' && (
          <span className='player-chips-info'>{WIN_TYPE_NAME[winType]}</span>
        )}

        {isPairWin && (
          <span
            className={`player-chips-top-block ${
              winType === ROUND_BET_TYPE_VIEW.PLAYER
                ? COLOR_BY_WIN_TYPE.PLAYER
                : COLOR_BY_WIN_TYPE.BANKER
            }`}
          />
        )}
      </div>
    </div>
  );
}
export default ResultItemMob;
